//global 全局通用配置相关api
import request from '@/utils/request'
import qs from 'qs'

// 图片视频文件上传
export function UpdataFile(file) {
  return request({
    url: '/admin/file/upload',
    method: 'post',
    data: file,
    // data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  })
}
export function systemContentlist(data) {
  return request({
    url: '/admin/systemContent/list',
    method: 'post',
    data
  })
}

export function systemContentsave(data) {
  return request({
    url: '/admin/systemContent/save',
    method: 'post',
    data
  })
}

export function systemContentupdate(data) {
  return request({
    url: '/admin/systemContent/update',
    method: 'post',
    data
  })
}
export function systemContentdelete(data) {
  return request({
    url: '/admin/systemContent/delete',
    method: 'post',
    data
  })
}
// 获取注册协议
export function Register() {
  return request({
    url: '/admin/systemContent/edit',
    method: 'post'
  })
}
// 更新注册协议
export function updataGlobalTExt(data) {
  console.log(data)
  return request({
    url: '/admin/systemContent/update',
    method: 'post',
    data: data
  })
}
// 根据IDS获取多个用户信息
export function getUserInfos(data) {
  return request({
    url: '/jiaoluo-me/admin/common/findMemberByIds',
    method: 'post',
    data: {
      ids: data
    }
  })
}
// 根据ID获取单个用户信息
export function getUserInfoByID(data) {
  return request({
    url: '/jiaoluo-me/memberCommon/findMemberInfoById',
    method: 'post',
    data: {
      memberId: data
    }
  })
}
// 根据username获取单个用户信息
export function getUserInfoByUserName(data) {
  return request({
    url: '/jiaoluo-me/admin/common/search/username/' + data,
    method: 'get'
  })
}
// 根据uid获取单个用户信息
export function getUserInfoByUid(data) {
  return request({
    url: '/jiaoluo-me/admin/common/search/uid/' + data,
    method: 'get'
  })
}

// 根据动态ID参看相关数据
export function findMemberInfoById(data) {
  return request({
    url: '/service-content/dynamicContentCommon/findMemberInfoByIds',
    method: 'post',
    data
  })
}
// 全部汽车品牌信息
export function getAllCarInfos() {
  return request({
    url: '/admin/common/findAllCar',
    method: 'post'
  })
}
// 获取全部礼物信息
export function getAllGiftInfos() {
  return request({
    url: '/admin/common/findAllGift',
    method: 'post'
  })
}
// 获取门槛礼物信息
export function getLimitGiftInfos() {
  return request({
    url: '/admin/common/findThresholdGift',
    method: 'post'
  })
}
// 获取标签列表
export function getGlobalTab() {
  return request({
    url: '/jiaoluo-me/admin/common/tab/list',
    method: 'post'
  })
}

// 获取年收入数据
export function getIncomeOptions() {
  return request({
    url: '/jiaoluo-me/admin/common/incomeOptions',
    method: 'post'
  })
}

// 获取全局参数
export function getGlobalParams() {
  return request({
    url: '/admin/common/findAllConfig',
    method: 'post'
  })
}
// 获取职业
export function jobOptions() {
  return request({
    url: '/jiaoluo-me/admin/common/jobOptions',
    method: 'post'
  })
}
// 获取聊天门槛
export function chatLimitOptions(data) {
  return request({
    url: '/jiaoluo-me/admin/member/chatLimitOptions',
    method: 'post',
    data
  })
}
// 获取聊天门槛
export function systemGiftlistAll() {
  return request({
    url: '/admin/systemGift/listAll',
    method: 'post'
  })
}
// 添加男性用户
export function addManMember(data) {
  return request({
    url: '/jiaoluo-me/memberCommon/saveBoyMember',
    method: 'post',
    data: data
  })
}
// 添加女性用户
export function addWomanMember(data) {
  return request({
    url: '/jiaoluo-me/memberCommon/saveGirlMember',
    method: 'post',
    data: data
  })
}
// 添加用户照片
export function addMemberPhoto(data) {
  return request({
    url: '/service-content/common/addMemberPhoto',
    method: 'post',
    data: data
  })
}

// 随机昵称
export function randomnickname() {
  return request({
    url: '/jiaoluo-me/admin/common/random/nickname',
    method: 'post'
  })
}

// 随机头像
export function randomavatar() {
  return request({
    url: '/jiaoluo-me/admin/common/random/avatar',
    method: 'post'
  })
}

// 根据根据用户Sns查询用户信息
export function findMemberBySns(data) {
  return request({
    url: '/jiaoluo-me/admin/common/findMemberBySns',
    method: 'post',
    data: {
      sns: data
    }
  })
}

// 随机旧版本用户
export function randomMember(data) {
  return request({
    url: '/jiaoluo-me/admin/common/randomMember',
    method: 'post',
    data: data
  })
}

// 根据频率ids查询频率列表
export function findByFids(data) {
  return request({
    url: '/jiaoluo-me/admin/atDynamic/findByFids',
    method: 'post',
    data: {
      ids: data
    }
  })
}

// 查看用户个人资料
export function memberbaseinfo(data) {
  return request({
    url: '/jiaoluo-me/admin/member/base/info',
    method: 'post',
    data: data
  })
}
// 获取乙方列表
export function yfnamelist() {
  return request({
    url: '/jiaoluo-me/admin/common/yf/name/list',
    method: 'post'
  })
}

// 时间戳转成年月日时分秒
export function shijianc(time) {
  var date = new Date(time)
  var Y = date.getFullYear() + '-'
  var M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':'
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}
//
export function upload(file) {
  return request({
    url: '/admin/file/upload',
    method: 'post',
    data: {
      file: file
    }
  })
}

// 获取七牛云token
export function getToken(data) {
  return request({
    url: '/admin/file/getToken',
    method: 'post'
    // headers: {
    //   memberId: data
    // }
  })
}
// action="https://upload.qiniup.com"

// 聊天新消息待处理数量
export function autoChatpendingCount() {
  return request({
    url: '/jiaoluo-me/admin/autoChat/pendingCount',
    method: 'post'
  })
}

// 动态内容
export function dynamiclist(data) {
  return request({
    url: '/jiaoluo-me/admin/member/dynamic/list',
    method: 'post',
    data
  })
}
